import { API_BASE } from "config/api";
import { withAuthHeaders } from "services/authHeader";
import { apiFetch } from "services/apiFetch";

export default async function getLangauges() {
  try {
    const url = new URL("api/languages/getLanguages", API_BASE);
    const res = await apiFetch(url, {
      method: "GET",
      headers: withAuthHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
    });

    const json = await res.json();
    if (json.status === "success") return Array.isArray(json.data) ? json.data : [];
    return [];
  } catch (error) {
    console.error("Error in getLanguages:", error);
    throw error;
  }
}
